import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { Popup, type PopupProps } from "react-map-gl";
import { mapViewStateAtom } from "~/stores";

export function MarkerLabel({
  title,
  lng,
  lat,
  size,
  anchor = "left",
}: {
  title: string;
  lng: number;
  lat: number;
  size: number;
  anchor?: PopupProps["anchor"];
}) {
  const { zoom } = useAtomValue(mapViewStateAtom);
  //absolute top-1/2 left-full transform translate-x-2 -translate-y-1/2 bg-white rounded-full px-2 py-0.5 whitespace-nowrap
  const offset = useMemo(() => {
    switch (anchor) {
      case "top":
        return [0, size * 0.5] as [number, number];
      case "bottom":
        return [0, size * 0.5 * -1] as [number, number];
      case "left":
        return [size * 0.5, 0] as [number, number];
      case "right":
        return [size * 0.5 * -1, 0] as [number, number];
    }
    return undefined;
  }, [size, anchor]);

  if (zoom && zoom < 3) {
    return null;
  }

  return (
    <Popup
      latitude={lat}
      longitude={lng}
      closeOnClick={false}
      closeOnMove={false}
      closeButton={false}
      className="popup__marker__label pointer-events-none select-none dark:text-black"
      anchor={anchor}
      offset={offset}
    >
      <div className="">{title}</div>
    </Popup>
  );
}
